/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { object, arrayOf, string, bool, shape } from "prop-types";
import classNames from "classnames/bind";
import merge from "lodash.mergewith";
import { Icon } from "../../components/Icons";
import { RCL } from "../../components/RCL";

import * as sharedStyles from "./SocialShareButtons.module.scss";
import {
	BASE_FACEBOOK_SHARED_URL,
	BASE_PINTEREST_SHARED_URL,
	BASE_SWG_URL,
	BASE_TWITTER_SHARED_URL,
} from "../../const/const";

let cx = classNames.bind(sharedStyles);

const defaultLabels = {
	publishedOn: "Published on",
	share: "share",
};

const SocialShareButtons = ({
	locale,
	location,
	displayDate,
	socialShareTitle,
	socialShareImage,
	displayFacebookLink,
	displayPinterestLink,
	displayTwitterLink,
	twitterHandle,
	twitterHashtags,
	styles,
	variant,
	labels: providedLabels,
}) => {
	cx = classNames.bind(merge(sharedStyles, styles));
	const labels = { ...providedLabels, ...defaultLabels };
	const locationHref = location?.href ? location.href : `${BASE_SWG_URL}${location?.pathname}`;

	return (
		<div
			className={cx(
				"socialShareButtonsContainer",
				"socialShareButtonsContainerCustom",
				variant === "plain" && "socialshareButtonsPlain",
				variant === "plain" && "socialshareButtonsPlainCustom"
			)}>
			{displayDate ? (
				<span className={cx("publicationDate", "publicationDateCustom")}>
					{labels.publishedOn} : {displayDate}
				</span>
			) : (
				<span className={cx("placeholder")} />
			)}

			<div className={cx("shareButtonsContainer", "shareButtonsContainerCustom")}>
				<span className={cx("shareButtonsLabel", "shareButtonsLabelCustom")}>{labels.share}</span>
				{displayFacebookLink && (
					<a
						href={`${BASE_FACEBOOK_SHARED_URL}${locationHref}${
							locale ? `&locale=${locale.replace("-", "_")}` : ""
						}`}
						target="_blank"
						className={cx(
							"socialMediaLink",
							"socialMediaLinkCustom",
							"facebook",
							"facebookCustom"
						)}>
						<span className="sr-only">
							<RCL searchKey="share-this-page-on-facebook" />
						</span>
						<Icon aria-hidden="true" name="facebook" />
					</a>
				)}

				{displayTwitterLink && (
					<a
						href={`${BASE_TWITTER_SHARED_URL}${locationHref}&${
							locale ? `lang=${locale.split("-")[0]}` : ""
						}&text=${socialShareTitle}${twitterHandle && `&via=${twitterHandle}`}${
							twitterHashtags !== null ? `&hashtags=${twitterHashtags.map(tag => `${tag}`)}` : ""
						}`}
						target="_blank"
						className={cx("socialMediaLink", "socialMediaLinkCustom", "twitter", "twitterCustom")}>
						<span className="sr-only">
							<RCL searchKey="share-this-page-on-twitter" />
						</span>
						<Icon aria-hidden="true" name="twitter" />
					</a>
				)}

				{displayPinterestLink && (
					<a
						href={`${BASE_PINTEREST_SHARED_URL}${
							locale ? `lang=${locale.split("-")[0]}` : ""
						}&url=${locationHref}&media=${socialShareImage}&description=${socialShareTitle}`}
						target="_blank"
						className={cx(
							"socialMediaLink",
							"socialMediaLinkCustom",
							"pinterest",
							"pinterestCustom"
						)}>
						<span className="sr-only">
							<RCL searchKey="share-this-page-on-pinterest" />
						</span>
						<Icon aria-hidden="true" name="pinterest" />
					</a>
				)}
			</div>
		</div>
	);
};

SocialShareButtons.propTypes = {
	locale: string,
	location: object,
	displayDate: string,
	socialShareTitle: string,
	socialShareImage: shape({
		file: shape({
			url: string,
		}),
	}),
	displayFacebookLink: bool,
	displayPinterestLink: bool,
	displayTwitterLink: bool,
	twitterHandle: string,
	twitterHashtags: arrayOf(string),
	styles: object,
	variant: string,
	labels: shape({ publishedOn: string }, { share: string }),
};
SocialShareButtons.defaultProps = {
	locale: null,
	location: null,
	displayDate: null,
	socialShareTitle: null,
	socialShareImage: null,
	displayFacebookLink: false,
	displayPinterestLink: false,
	displayTwitterLink: false,
	twitterHandle: "SunwingVacay",
	twitterHashtags: [],
	styles: null,
	variant: null,
	labels: defaultLabels,
};

export default SocialShareButtons;
export { SocialShareButtons };
